/**
 * Re-export xhr methods with browser auth data
 */
// TOOD: Use something browser fetch (or polyfill)
import { Response } from "superagent";

import { XHRClient } from "@/mk2/helpers/api";
import { makeRequest, makeRequestWithRetries } from "@/mk/xhr";
import { makeClientApiAuth, refreshApiAuthCsrfToken } from "@/mk/xhr/apiAuth";

export let apiAuth = makeClientApiAuth();

/**
 * Wait for device to become onLine
 *
 * @param waitTime How long we should wait - defaults to: 500ms
 * @param retries How many times we should try to wait - defaults to: 20
 */
async function waitForOnLine(waitTime = 500, retries = 20) {
    for (let i = 0; i <= retries; i++) {
        if (
            // eslint-disable-next-line n/no-unsupported-features/node-builtins
            typeof navigator === "undefined" ||
            // eslint-disable-next-line n/no-unsupported-features/node-builtins
            navigator.onLine !== false
        ) {
            return;
        }
        await new Promise((resolve) => setTimeout(resolve, waitTime));
    }
    // Continue as normal - try to make a request no matter of navigator.onLine value
}

export async function get(url: string, data?: any): Promise<Response> {
    await waitForOnLine();
    return makeRequestWithRetries(apiAuth, "GET", url, data);
}

export async function post(url: string, data?: any): Promise<Response> {
    await waitForOnLine();
    return makeRequest(apiAuth, "POST", url, data);
}

export const refreshApiAuth = () => {
    refreshApiAuthCsrfToken();
    apiAuth = makeClientApiAuth();
};

export const xhr: XHRClient = {
    get,
    post,
    refreshApiAuth,
};
